import { Heart, Layers, PackageCheck, Store } from "lucide-react";
import { Reveal } from "./Reveal";
import { SITE } from "../data/site";

const VALUES = [
  { icon: Heart, title: "Collector at heart", text: "Built on a genuine passion for collecting and trading cards." },
  { icon: Layers, title: "Growing, diverse inventory", text: "New cards and collectibles are being added all the time." },
  { icon: PackageCheck, title: "Organized fulfillment", text: "Carefully cataloged inventory, organized storage, and professional order fulfillment." },
  { icon: Store, title: "Marketplaces you trust", text: "Every order runs through established online marketplaces." },
];

export const About = () => (
  <section
    id="about"
    data-testid="about-section"
    className="relative scroll-mt-20 overflow-hidden border-t border-zinc-800/60 py-20 lg:py-28"
  >
    <img
      src="/brand/logo-circular-t.png"
      alt=""
      aria-hidden="true"
      className="pointer-events-none absolute -right-28 top-1/2 hidden w-[420px] -translate-y-1/2 opacity-[0.07] lg:block"
    />
    <div className="relative mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
      <Reveal>
        <p className="eyebrow" data-testid="about-eyebrow">
          About
        </p>
        <h2
          data-testid="about-heading"
          className="mt-3 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl"
        >
          An independent shop, built on the hobby
        </h2>
        <div className="mt-6 space-y-5 leading-relaxed text-zinc-400">
          <p>
            Sandstorm Trading is an independent online trading card and collectibles
            business that got its start in {SITE.established}. What began as a passion
            for collecting and trading cards has grown into a focused retail operation
            serving collectors and players across the hobby.
          </p>
          <p>
            We list our growing, diverse inventory through established online
            marketplaces — TCGPlayer, Mana Pool, eBay and CollX — so every purchase is
            backed by platforms you already know. Behind the scenes we keep things
            organized and professional, from careful card handling to listings we stand
            behind.
          </p>
          <p>
            The storm is still building — follow along as Sandstorm Trading keeps
            growing.
          </p>
        </div>
      </Reveal>
      <div className="grid gap-4 sm:grid-cols-2">
        {VALUES.map((v, i) => (
          <Reveal key={v.title} delay={i * 0.06}>
            <div
              data-testid={`about-value-${i}`}
              className="h-full rounded-xl border border-zinc-800 bg-[#12141A] p-6 transition-colors duration-300 hover:border-amber-500/40"
            >
              <div className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-amber-500/30 bg-amber-500/10">
                <v.icon className="h-5 w-5 text-amber-300" aria-hidden="true" />
              </div>
              <h3 className="mt-4 font-display text-base font-semibold text-zinc-100">
                {v.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-zinc-500">{v.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
